import { createActions } from 'redux-actions';

import { ENDPOINTS_EVENTS } from '../../config';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const {
  responseEvents,
  responseEventsOptions,
  requestEvents,
  responseEventsFailure,
  requestEventsOptions,
  responseEventsOptionsFailure,
  changeDefaultDate,
  toogleEventsCards,
  closeEventsCards,
} = createActions(
  {
    RESPONSE_EVENTS: data => ({ data }),
    RESPONSE_EVENTS_OPTIONS: data => ({ data }),
  },
  'REQUEST_EVENTS',
  'RESPONSE_EVENTS_FAILURE',
  'REQUEST_EVENTS_OPTIONS',
  'RESPONSE_EVENTS_OPTIONS_FAILURE',
  'CHANGE_DEFAULT_DATE',
  'TOOGLE_EVENTS_CARDS',
  'CLOSE_EVENTS_CARDS'
);

const filterQuery = (filters: any) => {
  const eventFilters = ['type', 'language', 'country', 'city'];
  let dataFilters: string[] = [];

  eventFilters.forEach((filter: string) => {
    const value = filters.get(filter);
    if (value !== '') {
      dataFilters = dataFilters.concat(`${filter}=${value}`);
    }
  });

  return dataFilters;
};

export function getEvents() {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    const filters = state.getIn(['events', 'filter']);

    dispatch(requestEvents());
    let queryString: string[] | string = ['order=-start', 'limit=500'];
    const newFilters = filterQuery(filters);

    queryString = queryString.concat(newFilters);
    queryString = queryString.length !== 0 ? `?${queryString.join('&')}` : '';

    return globalFetch(
      `${ENDPOINTS_EVENTS.events}${queryString}`,
      {
        method: 'GET',
        credentials: 'include',
      },
      dispatch,
      () => dispatch(responseEventsFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_PERFORMANCE_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(responseEvents(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(responseEventsFailure());
      });
  };
}

export function getEventsOptions() {
  return async (dispatch: any): Promise<object> => {
    dispatch(requestEventsOptions());

    return globalFetch(
      `${ENDPOINTS_EVENTS.events}`,
      {
        method: 'OPTIONS',
        credentials: 'include',
      },
      dispatch,
      () => dispatch(responseEventsOptionsFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'RESPONSE_EVENTS_OPTIONS_FAILURE')) {
          return dispatch(responseEventsOptionsFailure());
        }

        return dispatch(responseEventsOptions(json.actions.GET));
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(responseEventsOptionsFailure());
      });
  };
}
